import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';
import { services, company, waLink } from '../mock';
import useReveal from '../hooks/useReveal';

function ServiceCard({ s, index }) {
  const { ref, inView } = useReveal();
  return (
    <div
      ref={ref}
      style={{ animationDelay: `${index * 80}ms` }}
      className={`reveal ${inView ? 'in-view' : ''} card-hover group bg-white rounded-2xl border border-slate-100 shadow-sm p-6 flex flex-col`}
    >
      <div className="w-[72px] h-[72px] rounded-xl flex items-center justify-center mb-4 bg-slate-50 border border-slate-200">
        {s.logo ? (
          <img
            src={s.logo}
            alt={`${s.title} logo`}
            className="w-[52px] h-[52px] object-contain"
            style={{ filter: s.logoDark ? 'brightness(0)' : 'none' }}
          />
        ) : (
          <s.icon className="w-[42px] h-[42px]" style={{ color: s.color }} />
        )}
      </div>
      <h3 className="text-lg font-bold text-slate-900 font-display">{s.title}</h3>
      <p className="mt-2 text-sm text-slate-600 flex-1">{s.short}</p>
      <a
        href={waLink(`Hi Lockene, I want to apply for ${s.title}. Please assist me.`)}
        target="_blank"
        rel="noreferrer"
        className="mt-5 inline-flex items-center justify-center gap-2 w-full h-11 rounded-full font-semibold text-white transition-all group-hover:gap-3"
        style={{ background: s.color }}
      >
        Apply Now <ArrowRight className="w-4 h-4" />
      </a>
    </div>
  );
}

export default function Services() {
  return (
    <section id="services" className="py-20 lg:py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="text-primary font-semibold uppercase tracking-wider text-sm">What We Do</span>
          <h2 className="mt-2 text-3xl lg:text-4xl font-extrabold text-slate-900 font-display">
            Professional Compliance Service Solutions
          </h2>
          <p className="mt-3 text-slate-600">
            Helping your business stay compliant with ease and confidence across every major Indian certification.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {services.map((s, i) => (
            <ServiceCard key={s.id} s={s} index={i} />
          ))}
          {/* CTA tile */}
          <div className="rounded-2xl p-6 flex flex-col justify-center bg-[#0B2447] text-white shadow-lg">
            <Phone className="w-8 h-8 text-accent mb-3" />
            <h3 className="text-lg font-bold font-display">Need help choosing?</h3>
            <p className="text-sm text-slate-300 mt-1.5">Talk to a certified compliance expert for free guidance.</p>
            <a href={`tel:${company.phoneRaw}`} className="mt-4 inline-flex items-center gap-2 font-semibold text-accent hover:gap-3 transition-all">
              {company.phone} <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
